export const softColors = {
  primary: "#6B7280",
  background: "#F9FAFB",
  border: "#E5E7EB",
  hover: "#F3F4F6",
  success: "#388e3c",
  successBg: "#e8f5e9",
  successBorder: "#a5d6a7",
  error: "#d32f2f",
  errorBg: "#ffebee",
  errorBorder: "#ef9a9a",
  warning: "#f57c00",
  warningBg: "#fff4e5",
  warningBorder: "#ffcc80",
  info: "#1976d2",
  infoBg: "#e3f2fd",
  infoBorder: "#90caf9",
  retainer: "#9C27B0",
  retainerBg: "#F3E5F5",
  retainerBorder: "#CE93D8",
  text: "#374151",
  secondaryText: "#6B7280",
  final: "#885ccaff", 
};